import React from 'react';

const StaffingTabContext = React.createContext();

export default StaffingTabContext;
